import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckSquare, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ company_name: "", name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.ok) {
      toast.success("Empresa registrada");
      navigate("/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-2">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-slate-900 text-white">
            <CheckSquare className="h-6 w-6" />
          </div>
          <span className="font-heading text-lg font-extrabold text-slate-900">Calendario VH</span>
        </div>
        <h2 className="font-heading text-2xl font-extrabold text-slate-900">Registra tu empresa</h2>
        <p className="mt-1 text-sm text-slate-500">Crea tu cuenta de administrador</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><Label>Nombre de la empresa</Label><Input data-testid="reg-company" value={form.company_name} onChange={(e) => set("company_name", e.target.value)} className="mt-1" required /></div>
          <div><Label>Tu nombre</Label><Input data-testid="reg-name" value={form.name} onChange={(e) => set("name", e.target.value)} className="mt-1" required /></div>
          <div><Label>Correo electrónico</Label><Input data-testid="reg-email" type="email" value={form.email} onChange={(e) => set("email", e.target.value)} className="mt-1" required /></div>
          <div><Label>Contraseña</Label><Input data-testid="reg-password" type="password" value={form.password} onChange={(e) => set("password", e.target.value)} className="mt-1" required minLength={6} /></div>
          <Button data-testid="reg-submit" type="submit" disabled={loading} className="w-full rounded-full bg-slate-900 py-6 text-base font-bold hover:bg-slate-800 active:scale-95">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Crear cuenta"}
          </Button>
        </form>
        <div className="mt-4 text-center text-sm text-slate-500">
          ¿Ya tienes cuenta? <Link to="/login" className="font-semibold text-slate-900 underline">Inicia sesión</Link>
        </div>
      </div>
    </div>
  );
}
